import React, { useRef } from 'react';
import { ReportingShellContainerBaseConfig } from '../../../base';
import {
    InsertOverviewContainerProps,
    InsertOverviewViewProps,
} from './InsertOverviewProps';
import {
    InsertOverviewController,
    InsertOverviewLoader,
} from './InsertOverviewInterface';

export function createInsertOverviewContainer(
    config: ReportingShellContainerBaseConfig,
    loader: InsertOverviewLoader,
    controller: InsertOverviewController,
    View: React.FC<InsertOverviewViewProps>
): React.FC<InsertOverviewContainerProps> {
    const {
        UI: {
            Application: { createErrorBoundary },
        },
        context: { useContext },
    } = config;

    return ({ ...containerProps }) => {
        const context = useContext();
        const [searchValue, setSearchValue] = React.useState('');
        const [activeTab, setActiveTab] = React.useState<'template' | 'block'>(
            'template'
        );

        const data = loader.useLoad(context, containerProps);
        const props = controller.useProps(context, data, {
            field: {
                tab: {
                    value: activeTab,
                    onChange: setActiveTab,
                },
                search: {
                    value: searchValue,
                    onChange: setSearchValue,
                },
            },
        });
        return <View {...props} />;
    };
}
